var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCalendar2020 = function SvgIconCalendar2020(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M6 .25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 6 .25M14 .25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V1A.75.75 0 0 1 14 .25M.75 8.094a.75.75 0 0 1 .75-.75h17a.75.75 0 0 1 0 1.5h-17a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M2.737 4.385c-.64.69-.987 1.73-.987 3.115V16c0 1.385.346 2.425.987 3.115.631.68 1.656 1.135 3.263 1.135h8c1.607 0 2.631-.455 3.263-1.135.64-.69.987-1.73.987-3.115V7.5c0-1.385-.346-2.425-.987-3.115C16.63 3.705 15.607 3.25 14 3.25H6c-1.607 0-2.632.455-3.263 1.135m-1.1-1.02C2.633 2.295 4.108 1.75 6 1.75h8c1.893 0 3.369.545 4.362 1.615.984 1.06 1.388 2.52 1.388 4.135V16c0 1.615-.404 3.075-1.388 4.135-.993 1.07-2.469 1.615-4.362 1.615H6c-1.893 0-3.368-.545-4.362-1.615C.654 19.075.25 17.615.25 16V7.5c0-1.615.404-3.075 1.388-4.135",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#777E90",
    fillRule: "evenodd",
    d: "M12.695 12.703a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M12.695 15.703a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M8.996 12.703a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M8.996 15.703a1 1 0 0 1 1-1h.009a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M5.294 12.703a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M5.294 15.703a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1",
    clipRule: "evenodd"
  })));
};
export default SvgIconCalendar2020;